import { Themes } from '../../generic/theme/theme.models';
import grid from '../common/grid';
import animations from './animations';
import borders from './borders';
import buttons from './buttons';
import colors from './colors';
import fonts from './fonts';
import forms from './forms';
import modals from './modals';
import shadows from './shadows';
import transitions from './transitions';
const theme = {
    borders,
    buttons,
    colors,
    fonts,
    grid,
    modals,
    shadows,
    transitions,
    animations,
    forms,
    name: Themes.ZIGGO_WS2,
};
export default theme;
//# sourceMappingURL=index.js.map